import { useEffect, useRef, useState } from "react";

export function useFixedFooter(children: React.ReactNode, pageRef?: React.RefObject<HTMLDivElement | null>) {
  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    // Capturar a ref atual para usar no cleanup
    const currentPageRef = pageRef?.current;
    
    const updateFooterHeight = () => {
      if (footerRef.current) {
        const height = footerRef.current.offsetHeight;
        setFooterHeight(height);
        
        // Aplicar o padding-bottom no elemento da página se fornecido, senão no body
        const targetElement = currentPageRef || document.body;
        targetElement.style.paddingBottom = `${height}px`;
      }
    };

    // Atualizar altura imediatamente
    updateFooterHeight();

    // Observar mudanças de tamanho
    const resizeObserver = new ResizeObserver(updateFooterHeight);
    if (footerRef.current) {
      resizeObserver.observe(footerRef.current);
    }

    // Cleanup
    return () => {
      const targetElement = currentPageRef || document.body;
      targetElement.style.paddingBottom = "";
      resizeObserver.disconnect();
    };
  }, [children, pageRef]);

  return { footerRef, footerHeight };
}
